/*
 * File: /apps/web/src/tasker/redux/modules/taskerProfileState.js
 * Project: tr-web
 * Created Date: 2020-11-03
 * Author: Raif
 *
 * Copyright (c) 2020 TaskRabbit, Inc
 */

const SET_TASKERPROFILE_STATE =
  "v3/taskerProfile/taskerPhotos_SET_TASKERPROFILE_STATE";

const initialState = {
  redirectCategoryId: undefined,
  redirectQueryParams: "",
  taskerId: undefined,
};

export default function taskerProfile(state = initialState, action) {
  switch (action.type) {
    case SET_TASKERPROFILE_STATE: {
      return {
        ...state,
        redirectCategoryId: action.redirectCategoryId,
        redirectQueryParams: action.redirectQueryParams,
        redirectTo: action.redirectTo,
        taskerId: action.taskerId,
      };
    }
    default:
      return state;
  }
}

export const setTaskerProfileState = ({
  redirectCategoryId,
  redirectQueryParams,
  redirectTo,
  taskerId,
}) => {
  return {
    type: SET_TASKERPROFILE_STATE,
    redirectCategoryId,
    redirectQueryParams,
    redirectTo,
    taskerId,
  };
};
